import React, {useState, useEffect} from 'react';
import {Row, Col, Icon, Button, Card, Table, Modal} from 'antd';
import moment from 'moment';
import {getItemsPromise} from '../../../../../Monitoring/components/TabAlerts/promises';
import { ModalAlertCardPage } from '../../../../../';
import { useTranslation } from 'react-i18next'
const Monitoreo = ({currentUser, itemTable}) => {

    const [seeMore, setseeMore] = useState(null);
    const [monitorItems, setMonitorItems] = useState(null);
    const [alertRow, setAlertRow] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        getItemsPromise('N' ,{recordId: itemTable.id, size: 1000}).then(response => {
            setMonitorItems(response.data.records);
        })
    }, []);

    const monitorCardStyle = {
        textAlign: 'center',
        backgroundColor: "#0A2D44",
        color: 'white',
        padding: "5px 0px 5px 0px"
    }

    const monitoreoColumns = [
        {
            title: t("messages.aml.type"),
            dataIndex: "type",
            render: (text) => {
                return <div style={{textTransform: 'capitalize'}}>
                {text.toLowerCase()}
                </div>
            }
        },
        {
            title: t("messages.aml.risk"),
            dataIndex: "score"
        },
        {
            title: t("messages.aml.folio"),
            dataIndex: "folio"
        },
        {
            title: t("messages.aml.reception"),
            dataIndex: "creationDate",
            render: (text) => {
                return moment(text).format("DD/MM/YYYY")
            }
        },
        {
            title: t("messages.aml.status"),
            dataIndex: "status",
            render: (text) => {
                return t("messages.aml.alert.status."+text)
            }
        },
        {
            title: t("messages.aml.statusDate"),
            dataIndex: "dateStatus",
            render: (date) => {
                if(date){
                return moment(date).format("DD/MM/YYYY")
                }else{
                return t("messages.aml.noDate")
                }
            }
        },
        {
            title: t("messages.aml.tasks"),
            dataIndex: "nroTareas",
            render: (task) => {
                return task > 0 ? t("messages.aml.si") : t("messages.aml.no")
            }
        },
    ]
    return (
        <div>
            <Row>
                <Col span={22}>
                    <h3>{t("messages.aml.monitoringAlertManager")}</h3>
                </Col>
                { monitorItems &&
                    <Col span={2} style={{textAlign:'right'}}>
                        <Button type="link" onClick={() => {setseeMore(!seeMore)}}>
                            {seeMore ?
                            <>{t("messages.aml.seeLess")} <Icon type="minus"/></>
                            :
                            <>{t("messages.aml.seeMore")} <Icon type="plus"/></>
                            }
                        </Button>
                    </Col>
                }
            </Row>
            <hr/>
            {seeMore &&
                <div className='cards-wrapper-mcc'>
                <Row type="flex" gutter={[10]}>
                    <Col span={2}> 
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.alerts")}: <br/> {monitorItems.length}
                        </Card>
                    </Col>
                    <Col span={2}>
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.pending")}: <br/> {monitorItems.filter((item) => item.status === "OPEN").length}
                        </Card>
                    </Col>
                    <Col span={2}>
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.closed")}: <br/> {monitorItems.filter((item) => item.status === "CLOSE").length}
                        </Card>
                    </Col>
                    <Col span={10}>
                    </Col>
                    <Col span={2}>
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.critical")}: <br/> {monitorItems.filter((item) => item.score === 4).length}
                        </Card>
                    </Col>
                    <Col span={2}>
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.high")}: <br/> {monitorItems.filter((item) => item.score === 3).length}
                        </Card>
                    </Col>
                    <Col span={2}>
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.medium")}: <br/> {monitorItems.filter((item) => item.score === 2).length}
                        </Card>
                    </Col>
                    <Col span={2}>
                        <Card bodyStyle={monitorCardStyle}>
                            {t("messages.aml.low")}: <br/> {monitorItems.filter((item) => item.score === 1).length}
                        </Card>
                    </Col>
                </Row>
                <Row type="flex" style={{marginTop: '20px'}}>
                    <Col span={24}>
                        <Table
                            dataSource={monitorItems}
                            columns={monitoreoColumns}
                            bordered
                            size="small"
                            pagination={monitorItems.length > 10}
                            rowClassName="selected-alert-monitor-row"
                            onRow={(record) => {
                            return {
                                onClick: () => {
                                    setAlertRow(record)
                                    // setHasDetailModal(false)
                                }
                            };
                        }}
                    />
                    </Col>
                </Row>
                </div>
            }
            {alertRow &&
                <Modal
                    className="modal-alert-card"
                    visible={ true }
                    header={ null }
                    footer={ null }
                    onCancel={ () => setAlertRow(false) }
                    style={{top: '20px'}}
				    bodyStyle={{padding: '0px 0px 0px 0px'}}
                    width={'95vw'}
                >
                    <ModalAlertCardPage
                        item={alertRow}
                        currentUser={currentUser}
                        closeOverlayAlerta={() => setAlertRow(false)}
                    />
                </Modal>
            }
        </div>
    );
};

export default Monitoreo;